var map = {
	"./template.betgalaxy": 1071,
	"./template.betgalaxy.tsx": 1071,
	"./template.betprofessor": 1072,
	"./template.betprofessor.tsx": 1072,
	"./template.betroyale": 2115,
	"./template.betroyale.tsx": 2115,
	"./template.default": 657,
	"./template.default.tsx": 657,
	"./template.fiestabet": 2016,
	"./template.fiestabet.tsx": 2016,
	"./template.forsport": 1073,
	"./template.forsport.tsx": 1073,
	"./template.puntcity": 1074,
	"./template.puntcity.tsx": 1074,
	"./template.puntgenie": 1075,
	"./template.puntgenie.tsx": 1075,
	"./template.questbet": 1076,
	"./template.questbet.tsx": 1076,
	"./template.ts": 287,
	"./template.volcanobet": 1077,
	"./template.volcanobet.tsx": 1077,
	"./template.wellbet": 2116,
	"./template.wellbet.tsx": 2116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2420;